// extracted by mini-css-extract-plugin
module.exports = {"container":"index_container__I2Peg","arrowIcon":"index_arrowIcon__gXf_E"};